import {__, construct, curry, tryCatch} from 'ramda';
import EventTargetPolyfill from '../polyfills/EventTarget';

const createEventTarget = tryCatch(
    construct(EventTarget),
    construct(EventTargetPolyfill)
);

const eventBus = createEventTarget();

/**
 *
 * @param {Function} target
 * @param {object|null} thisArg
 * @param {array} argumentsList
 * @param {string} eventName
 */
const apply = (target, thisArg, argumentsList, eventName) => {
    let result = Reflect.apply(target, thisArg, argumentsList);

    eventBus.dispatchEvent(new CustomEvent(eventName, {detail: result}));

    return result;
}

const handler = (eventName) => ({
    apply: curry(apply)(__, __, __, eventName)
})

const showWait = new Proxy(BX.showWait, handler('showWait'));
const closeWait = new Proxy(BX.closeWait, handler('closeWait'));

BX.showWait = showWait;
BX.closeWait = closeWait;

export {
    eventBus as default,
    showWait,
    closeWait,
};
